import { getMessage, replaceArguments } from './format';
export const createMessageFormatter = (messages, options) => (term, args) => {
    const message = getMessage(messages, term, args, options);
    if (args)
        return replaceArguments(message, args);
    return message;
};
//# sourceMappingURL=message.js.map